import React, { useRef } from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Button, CircularProgress, TextField, Tooltip } from '@material-ui/core'
import copy from 'copy-to-clipboard'
import { ImagePicker } from '~views/shared'
import { Save } from '@material-ui/icons'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { useStyles } from './LayoutForm.style'
import { validateExtension } from 'views/utils/functions'

const validationSchema = Yup.object().shape({
  LayoutName: Yup.string()
    .required('Es requerido ingresar un nombre')
    .max(250, 'La cantidad máxima es de 250 caracteres'),
  ImageFile: Yup.mixed().required('Es requerido subir una imagen')
})

export const LayoutForm = ({
  values,
  actionText,
  handleSubmit,
  onCancel,
  actionPending
}) => {
  const classes = useStyles()
  const fileInput = useRef(null)

  const copyToClipBoard = (urlImage) => {
    try {
      copy(urlImage)
      showSnackbarSuccess('¡Imagen copiada al portapapeles!')
    } catch (error) {
      showSnackbarError(error)
    }
  }

  const handleSelectImage = () => {
    fileInput.current.click()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={values}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}>
      {({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldError,
        setFieldTouched,
        isSubmitting
      }) => (
        <form
          noValidate
          onSubmit={handleSubmit}
          className={classes.formContainer}>
          <div className={classes.fieldsContainer}>
            <div className={classes.fieldRow}>
              <TextField
                label='Nombre de la Planimetria'
                name='LayoutName'
                value={values.LayoutName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(touched.LayoutName && errors.LayoutName)}
                helperText={
                  touched.LayoutName && errors.LayoutName
                    ? errors.LayoutName
                    : ''
                }
                fullWidth
                required
                size='small'
                variant='outlined'
                InputLabelProps={{ shrink: Boolean(values.LayoutName) }}
                className={classes.field}
              />
            </div>
            <div style={{ marginLeft: 16 }}>
              <input
                type='file'
                id='imageFile'
                style={{ display: 'none' }}
                accept='.png,.jpg,.jpeg,.pjp,.pjpeg,.jfif'
                onChange={(event) => {
                  if (event.target.files.length > 0) {
                    const file = event.target.files[0]
                    if (validateExtension(file.name)) {
                      setFieldValue('ImageFile', file)
                      setFieldError('ImageFile', '')
                    }
                  }
                }}
                ref={fileInput}
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}>
                <Button
                  onClick={handleSelectImage}
                  color='primary'
                  variant='contained'
                  style={{
                    marginRight: 10,
                    textTransform: 'none',
                    marginBlock: 16
                  }}>
                  Seleccionar Imagen
                </Button>
                {!!values.ImageFile && (
                  <Tooltip
                    title={values.ImageFile.name ?? 'Imagen'}
                    placement='right'>
                    <div>
                      <ImagePicker
                        className={classes.imagePicker}
                        onImageChange={() => {}}
                        onClickImage={copyToClipBoard}
                        url={
                          values.ImageFile instanceof File
                            ? URL.createObjectURL(values.ImageFile)
                            : values.ImageFile || ''
                        }
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
              {errors.ImageFile && touched.ImageFile && (
                <div style={{ color: 'red' }}>{errors.ImageFile}</div>
              )}
            </div>
          </div>
          <div className={classes.actionsContainer}>
            <Button
              onClick={onCancel}
              disabled={isSubmitting}
              autoFocus={false}
              color='primary'>
              Cancelar
            </Button>
            <Button
              onClick={() => {
                values.LayoutName = values.LayoutName.trim()
                Object.keys(values).forEach((key) => {
                  setFieldTouched(key, true)
                })
                handleSubmit()
              }}
              disabled={actionPending || isSubmitting}
              color='primary'
              variant='contained'
              startIcon={<Save />}
              autoFocus={false}>
              {actionPending || isSubmitting ? (
                <CircularProgress size={24} color='secondary' />
              ) : (
                actionText
              )}
            </Button>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default LayoutForm
